import { StopSalesBlockType, StopSalesRange } from 'api/fleet/types'
import { STOP_SELLS_DETAILS_FORM_VALUES } from 'texts/stopSellsDetails'

export const initialFormValues = {
  countries: [],
  cities: [],
  locations: [],
  carClasses: [],
  from: '',
  to: '',
  comments: '',
  applicable: StopSalesRange.Both,
  blockType: StopSalesBlockType.Temporary,
}

export const BLOCK_TYPE_RADIO_BUTTONS = [
  {
    label: 'Permanent',
    id: StopSalesBlockType.Permanent,
    tooltip: STOP_SELLS_DETAILS_FORM_VALUES.BLOCK_TYPE.PERMANENT_TOOLTIP,
  },
  {
    label: 'Temporary',
    id: StopSalesBlockType.Temporary,
    tooltip: STOP_SELLS_DETAILS_FORM_VALUES.BLOCK_TYPE.TEMPORARY_TOOLTIP,
  },
]

export const RADIO_BUTTONS = [
  { label: 'All', id: StopSalesRange.Both },
  { label: 'Pick-up', id: StopSalesRange.PickUp },
  { label: 'Drop-off', id: StopSalesRange.DropOff },
]

export const MAX_DATE = '31.12.2999'
